import script from "./ConsoleWorkspaceDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsoleWorkspaceDetail.vue?vue&type=script&setup=true&lang=js"

import "./ConsoleWorkspaceDetail.vue?vue&type=style&index=0&id=6c566856&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c566856"]])

export default __exports__